/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { IWidgetVotingReducer } from './types/widgetVotingTypes';

export const makeSelectorWidgetVotingState = (state: IRootReducer): IWidgetVotingReducer =>
    state.dashboard.widgetVoting;

export const makeSelectorWidgetVotingAnonymous = ():
    OutputSelector<IRootReducer, boolean, (state: IWidgetVotingReducer) => boolean> =>
    createSelector(
        makeSelectorWidgetVotingState,
        (state: IWidgetVotingReducer) => state.data.anonymous,
    );

export const makeSelectorWidgetVotingDaysSpan = ():
    OutputSelector<IRootReducer, number, (state: IWidgetVotingReducer) => number> =>
    createSelector(
        makeSelectorWidgetVotingState,
        (state: IWidgetVotingReducer) => state.data.daysSpan,
    );

export const makeSelectorWidgetVotingUrl = ():
    OutputSelector<IRootReducer, string, (state: IWidgetVotingReducer) => string> =>
    createSelector(
        makeSelectorWidgetVotingState,
        (state: IWidgetVotingReducer) => state.data.url,
    );

export const makeSelectorWidgetVotingUserId = ():
    OutputSelector<IRootReducer, number, (state: IWidgetVotingReducer) => number> =>
    createSelector(
        makeSelectorWidgetVotingState,
        (state: IWidgetVotingReducer) => state.data.userId,
    );
